module.exports = __webpack_public_path__ + "static/media/gameboard-o.0ca1de6b.svg";